<template>
    <div class="myself-message-body">
        <div class="message-content">
            <template>    
                <div class="message-text" :style="{background: colors.message.myself.bg, color: colors.message.myself.text}">
                    <p class="message-username">{{myself.name}}</p>
                    <p ref="message-content">{{message.content}}</p>
                </div>
            </template>
            <div class="message-timestamp" :style="{'justify-content': 'flex-end'}">
                    {{message.timestamp}}
            </div>
        </div>
        <div class="thum-container">
            <img class="participant-thumb" :src="myself.profilePic"
                style="width: 30px; height: 30px; border-radius: 50%;">
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            myself: {
                type: Object,
                required: true
            },
            message: {
                type: Object,
                required: true
            },
            colors: {
                type: Object,
                required: true
            },
        }
    }
</script>